.actions {
  margin: 1rem 0;
}

.paragraph {
  margin: 0 0 1rem;
}
